import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup'
import Axios from 'axios';
import PmsUrlConfig from '../../urlConfig';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import ServiceLocation from './ServiceLocationComponent';
import { handleServiceTypeChange, getPractice, setAuthToken, getServiceTypeLabel } from '../common';
import ErrorMessages from '../../errorConfig';
import { logout } from '../common';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* eslint-disable */
export default function EditServiceLocation({ handleEditServiceClose }) {

    const dispatch = useDispatch();
    const [isDeleting, setIsDeleting] = useState(false);
    const practiceDetails = useSelector(state => state.practiceDetails);
    const [showDeleteService, setShowDeleteService] = useState(false);
    if (!practiceDetails)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;
    if (!practice)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const loginDetails = useSelector(state => state.loginDetails);
    var serviceTypes = [];
    var token = "";
    if (loginDetails) {
        serviceTypes = loginDetails.serviceTypes;
        token = loginDetails.jwtToken;
    }

    const selectedService = practiceDetails.selectedService;
    const [pmsServiceType, setPmsServiceType] = useState(() => {
        if (selectedService != null && practice.selectedService != null) {
            return selectedService.service_types;
        }
        return [];
    });

    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;


    const addressSchema = Yup.object().shape({
        locationName: Yup.string().required('Required!'),
        editServiceStreet1: Yup.string().required('Required!'),
        editServiceCity: Yup.string().required('Required!'),
        editServiceState: Yup.string().required('Required!'),
        editServiceZipcode: Yup.string().required('Required!')
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
        pmsServiceType: Yup.array().min(1, 'At least one department is required').of(Yup.object().shape({
            label: Yup.string().required('Required!'),
            value: Yup.string().required('Required!'),
        })),
    })

    const practiceId = practice._id

    var defaultServiceTypes = [];
    if (selectedService != null) {
        var servType;
        if (selectedService.service_types != null) {
            // serTypes = selectedService.service_types;
            selectedService.service_types.map((sType) => {

                servType = {
                    "label": getServiceTypeLabel(sType.service_code, serviceTypes),
                    "value": sType.service_code
                }
                defaultServiceTypes.push(servType)
            })
        }
    }

    const handleReset = () => {
        var divElem = document.getElementById("editServiceLocation_form");
        Array.from(divElem.querySelectorAll("input")).forEach(
            input => {
                input.value = "";
            }
        );
        Array.from(document.getElementById("editServiceLocation_form").getElementsByClassName("invalid-feedback")).forEach(
            divElem => (divElem.innerHTML = "")
        );
        defaultServiceTypes = [];

        dispatch({
            type: 'clearMsg'
        })
    };
    const handleDeleteServiceShow = () => {
        setShowDeleteService(true);
    }
    const handleDeleteServiceClose = () => {
        setShowDeleteService(false);
        dispatch({
            type: 'clearMsg'
        })
        getPractice(practice._id, dispatch, token);
    }

    const handleDeleteServiceSubmit = () => {
        const practiceId = practice._id
        setIsDeleting(true);
        var deleteServiceUrl = PmsUrlConfig.BOS_DELETE_SERVICE_URL + practiceId + "/" + selectedService._id;
        setAuthToken(token);
        Axios.post(deleteServiceUrl)
            .then((response) => {
                if (response.status === 200) {
                    toast.success('Service location deleted successfully!', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                    handleDeleteServiceClose();
                    handleEditServiceClose();
                    setIsDeleting(false);
                    dispatch({
                        type: 'deleteServiceSuccess',
                        payload: response.data
                    })
                }
                else if (response.status === 400) {
                    const errorMessage = response.data?.error_code?.description || 'Server error occurred';
                    toast.error(errorMessage, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                    setIsDeleting(false);
                    dispatch({
                        type: 'practiceUpdateError',
                        payload: response.data.error_code.description
                    })
                }
            }).catch((error) => {
                const errorMessage = error.response?.data?.error_code?.description || error.message || 'Server error occurred';
                toast.error(errorMessage, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                // dispatch({
                //     type: 'practiceUpdateError',
                //     payload: error.response.data.error_code.description
                // })
                console.log(error)
                setIsDeleting(false);
            })
    }
    return (
        <div className="w-full max-w-4xl mx-auto p-4 sm:p-6" id="edit-service-form">
            <Formik
                initialValues={{
                    locationName: selectedService.location_name,
                    editServiceStreet1: selectedService.service_address.street1,
                    editServiceStreet2: selectedService.service_address.street2,
                    editServiceCity: selectedService.service_address.city,
                    editServiceState: selectedService.service_address.state,
                    editServiceZipcode: selectedService.service_address.zip_code,
                    pmsServiceType: defaultServiceTypes
                }}
                validationSchema={addressSchema}
                onSubmit={(values, { setSubmitting }) => {
                    var editServiceUrl = PmsUrlConfig.BOS_EDIT_SERVICE_URL + practiceId;
                    setAuthToken(token);
                    
                    // Convert react-select format back to API format
                    const serviceTypesPayload = practiceDetails.selectedServiceTypes ? 
                        practiceDetails.selectedServiceTypes.map(st => ({
                            service_code: st.value,
                            service_name: st.label
                        })) : [];
                    
                    Axios.post(editServiceUrl,
                        {
                            _id: selectedService._id,
                            location_name: values.locationName,
                            service_address: {
                                street1: values.editServiceStreet1,
                                street2: values.editServiceStreet2,
                                city: values.editServiceCity,
                                state: values.editServiceState,
                                zip_code: values.editServiceZipcode,
                            },
                            service_types: serviceTypesPayload,
                        }
                    ).then((response) => {
                        if (response.status === 200) {
                            toast.success('Service location updated successfully!', {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            handleReset();
                            getPractice(practiceId, dispatch, token);
                            dispatch({
                                type: 'practiceUpdateSuccess',
                                // payload: response.data
                            })
                            setSubmitting(false);
                            // Close the modal after successful update
                            if (handleEditServiceClose) {
                                handleEditServiceClose();
                            }
                        }
                        else if (response.status === 400) {
                            const errorMessage = response.data?.error_code?.description || 'Server error occurred';
                            toast.error(errorMessage, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            if (response.data.error_code)
                                dispatch({
                                    type: 'practiceUpdateError',
                                    payload: response.data.error_code.description
                                })
                            else
                                dispatch({
                                    type: 'practiceUpdateError',
                                    payload: ErrorMessages.SERVER_ERROR
                                })
                            setSubmitting(false);
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        const errorMessage = error.response?.data?.error_code?.description || error.message || 'Server error occurred';
                        toast.error(errorMessage, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                        if (error.response.data && error.response.data.error_code)
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: error.response.data.error_code.description
                            })
                        else
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: ErrorMessages.SERVER_ERROR
                            })
                        setSubmitting(false);
                    })
                }}
            >
                {({ errors, touched, values, handleChange, handleBlur, setSubmitting, handleReset, isSubmitting, setFieldValue }) => (
                    <Form id="editServiceLocation_form" className="space-y-6">
                        <div className="w-full">
                            <ServiceLocation
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                handleReset={handleReset}
                                setSubmitting={setSubmitting}
                                isSubmitting={isSubmitting}
                                successMsg={successMsg}
                                errorMsg={errorMsg}
                                handleServiceTypeChange={handleServiceTypeChange}
                                serviceTypes={serviceTypes}
                                setFieldValue={setFieldValue}
                                defaultServiceTypes={defaultServiceTypes}
                                prefix={'editService'}
                                dispatch={dispatch}
                            />
                        </div>
                        
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-start sm:justify-end">
                            <button
                                type="submit"
                                className="px-6 py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                onClick={handleDeleteServiceShow}
                                className="px-6 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                            >
                                Delete Service Location
                            </button>
                        </div>
                        
                        <Modal show={showDeleteService} onHide={handleDeleteServiceClose}>
                            <Modal.Header closeButton className="border-b border-gray-200">
                                <Modal.Title className="text-xl font-semibold text-gray-900">Delete Service</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="px-6 py-4">
                                <p className="text-gray-700">Are you sure you want to delete the selected service permanently?</p>
                            </Modal.Body>
                            <Modal.Footer className="border-t border-gray-200">
                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                                    <button
                                        onClick={handleDeleteServiceSubmit}
                                        disabled={isDeleting}
                                        className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                    >
                                        {isDeleting ? "Deleting..." : "Yes"}
                                    </button>
                                    <button
                                        onClick={handleDeleteServiceClose}
                                        className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={handleDeleteServiceClose}
                                        className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                    >
                                        Close
                                    </button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                )}
            </Formik>
        </div>
    )

}